import SelectInput from 'app/components/Form/Inputs/SelectInput';
import RichText from 'app/components/RichText';
import ToggleButton from 'app/components/ToggleButton';
import { _t } from 'app/utils/i18n';
import React, { FunctionComponent } from 'react';
import { useFieldArray } from 'react-hook-form';
import styles from './ReportInformation.module.scss';

interface Props {
  trigger: any;
  name: string | any;
  onChange: (name: string, value: any) => void;
  values: any;
  errors: any;
  setError: any;
  control: any;
  moduleName: string;
  activeTemplates: any;
}

const ReportInformation: FunctionComponent<Props> = ({
  control,
  errors,
  trigger,
  values,
  activeTemplates,
  setError,
  onChange,
}) => {
  const { append: appendReportSection } = useFieldArray({
    control,
    name: 'sections',
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const addField = async () => {
    const res = await trigger('sections');
    if (
      res &&
      !!values.sections[0]?.title &&
      !!values.sections[0]?.description
    ) {
      appendReportSection({});
      return;
    } else if (!values.sections[0]?.title && !values.sections[0]?.description) {
      setError(`sections[${0}].title`, {
        type: 'manual',
        message: _t('influencers:must_fill_first_field'),
      });
      setError(`sections[${0}].description`, {
        type: 'manual',
        message: _t('influencers:must_fill_first_field'),
      });
    }
  };
  return (
    <div className={styles.ReportInformation}>
      <div className={styles.ReportInformation__Wrapper}>
        <SelectInput
          placeholder=" "
          options={activeTemplates}
          name="report_template"
          onChange={(val) => {
            onChange('report_template', val);
            onChange('charts', null);
          }}
          value={values.report_template}
          label={_t('reports:report_template') + '*'}
          isEdit
          error={errors?.report_template?.message}
          disabled={!!values.report_id}
        />

        <RichText
          label={_t('reports:report_summary')}
          name="description"
          value={values.description}
          onChange={(val) => {
            onChange('description', val);
          }}
        />
        <br />
        <div className={styles.Section__Wrapper__Title}>
          <span>{_t('reports:chart_desc')}</span>
          <ToggleButton
            onChange={(event: any) =>
              onChange('allow_blank_description', event.target?.checked)
            }
            value={values?.allow_blank_description}
          />
        </div>

        {/* {sections?.map((reportSection, index) => (
          <div className={styles.Section} key={index}>
            <div className={styles.Section__Wrapper}>
              <div className={styles.Section__Wrapper__Title}>
                <h3>{`${_t('reports:sections')}  ${index + 1}`}</h3>
                {sections?.length > 1 && (
                  <IconButton onClick={() => removeReportSection(index)}>
                    <TrashIcon />
                  </IconButton>
                )}
                {sections?.length == 1 &&
                  (values?.sections?.[index]?.title?.length > 0 ||
                    values?.sections?.[index]?.description?.length > 0) && (
                    <IconButton
                      onClick={() =>
                        updateReportSection(index, {
                          title: '',
                          description: '',
                          id: reportSection.id,
                        })
                      }
                    >
                      <ResetIcon />
                    </IconButton>
                  )}
              </div>
              <TextInput
                label={_t('reports:title')}
                name={`sections[${index}].title`}
                register={register}
                value={values?.sections?.[index]?.title}
                error={errors?.sections?.[index]?.title?.message}
              />
              <TextareaInput
                label={_t('reports:description')}
                rows={3}
                name={`sections[${index}].description`}
                value={values?.sections?.[index]?.description}
                register={register}
                error={errors?.sections?.[index]?.description?.message}
              />
            </div>
            {sections.length === index + 1 && (
              <div className={styles.Section__Button}>
                <button onClick={addField} className={`mb-20 ${styles.Button}`}>
                  <AddICon
                    style={{
                      width: 9,
                      height: 9,
                      marginInlineEnd: 5,
                    }}
                  />
                  {_t('reports:add_field')}
                </button>
              </div>
            )}
          </div>
        ))} */}
      </div>
    </div>
  );
};

export default ReportInformation;
